import * as React from 'react';
import {Report} from '../../reports/types/Report';
import {ReportListEntry} from '../../reports/types/ReportListEntry';
import CallbackHelpers from '../helpers/CallbackHelpers';
import {Func} from '../types/Func';

export interface ReportCacheProps {
  getAvailableReports: Func<ReportListEntry[]>;
  getDraftReport: (reportId: string) => Report | undefined;
  getPublishedReport: (reportId: string) => Report | undefined;
  clearReportCache: (reportId?: string) => void;
}

export const ReportCache = React.createContext<ReportCacheProps>({
  getAvailableReports: CallbackHelpers.ReturnEmptyArray,
  getDraftReport: CallbackHelpers.ThrowNotImplemented,
  getPublishedReport: CallbackHelpers.ThrowNotImplemented,
  clearReportCache: CallbackHelpers.ThrowNotImplemented
});
